import React from 'react';
import {
  ContentDeciderContainer,
  getTranslatedText,
  SkeletonLoading,
  TableContainer,
  getColumnWidth as superTableColumnWidth,
  saveColumnWidth,
  SuperList
} from '@nile/components';
import { useIntl } from 'react-intl';
import envConfig from '@nile/home/src/Config/env';
import { RMMClient } from '@nile/graphql';
import {
  columnsConfig,
  getAttributeName
} from '@nile/rmm/src/modules/alert-management/services/alert-list-helper.service';
import { GET_ALERTS_FOR_ASSET } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { GET_ALERT_LIST } from '@nile/rmm/src/modules/alert-management/Graphql/alert';

const defaultOptions = {
  page: 1,
  sort: [
    {
      attribute: 'createdTime',
      order: 'DESC'
    }
  ],
  condition: null
};
const tableTypeMap = {
  assetTable: {
    apiName: 'getAlertsForAsset',
    api: GET_ALERTS_FOR_ASSET
  },
  reportTableTable: {
    apiName: 'getAlertList',
    api: GET_ALERT_LIST
  }
};

const AlertsTable = (props) => {
  const {
    alertListLoading,
    noBulkSelect,
    listLoader,
    records,
    setRecords,
    columnGroup,
    user,
    tableName,
    assetId,
    alertList,
    setAlertList,
    tableCondition,
    personalizedSorting,
    defaultCondition,
    tableType
  } = props;
  const intl = useIntl();
  return (
    <TableContainer>
      <ContentDeciderContainer
        isLoading={alertListLoading}
        hasContent
        fullHeight
        mainContent={
          <SuperList
            fullHeight
            noBulkSelect={noBulkSelect}
            isLoading={listLoader}
            records={records}
            setRecords={setRecords}
            columns={columnGroup}
            user={user}
            saveColumnWidth={saveColumnWidth}
            tableName={tableName}
            viewId={assetId}
            columnWidthPersonalization
            defaultColumnCells={columnsConfig}
            data={alertList || []}
            setData={setAlertList}
            getAttributeName={getAttributeName}
            emptyState={{
              nodataImage: `${envConfig.imageRoot}svg/alert-empty-state.svg`,
              heading: getTranslatedText(intl, 'alert.noAlertFound.heading'),
              description: getTranslatedText(intl, 'alert.noAlertFound.desc')
            }}
            padded="lg"
            checkBoxSize="lg"
            sortingPersonalization
            client={RMMClient}
            query={tableTypeMap[tableType].api}
            accessorKey={tableTypeMap[tableType].apiName}
            dataKey="alerts"
            additionalVariables={{
              assetId: tableType === 'assetTable' ? assetId : null
            }}
            tableCondition={tableCondition}
            defaultSort={personalizedSorting || defaultOptions.sort}
            defaultCondition={defaultCondition}
          />
        }
        loadingContent={
          <SkeletonLoading
            hideStepNav={true}
            hideSecondaryHeader={true}
            hideHeader={true}
          />
        }
      />
    </TableContainer>
  );
};

export default AlertsTable;
